module.exports = __webpack_public_path__ + "img/icon-consult.802fb629.png";